<template>
    <div class="DesktopView ">
        <div class="container-wrap ">
            <div class="TableContent">
                <div class="row d-flex justify-content-end ">
                    <div class="col-lg-5 left-box ps-3 pe-3 pb-3">
                        <span class="mb-3 mt-3 d-block location-text">{{ "LEVEL "+apartmentdetail.level  }} </span>
                        <h2>
                            {{ apartmentdetail.flat_no }}
                        </h2>
                        <span class="d-block fs-08">
                            {{ apartmentdetail.beds  }} Bedroom Apartment
                        </span> 
                        <span class="d-block fs-08">
                            Total GIA {{ apartmentdetail.gia }} sq m / {{ apartmentdetail.sqm }} sq ft
                        </span>
                        <table class="table desktopTable mt-3">
                            <tbody v-if="apartmentdetail.lenght != 0">
                                <tr>
                                    <th scope="col">Kitchen/Living</th>
                                    <th scope="col">{{ apartmentdetail.kitchen_living_m }}</th>
                                    <th scope="col">{{ apartmentdetail.kitchen_living_ft }}</th> 
                                </tr>
                                <tr>
                                    <th scope="col">Bedroom 1</th>
                                    <th scope="col">{{ apartmentdetail.principal_bedroom_m }}</th>
                                    <th scope="col">{{ apartmentdetail.principal_bedroom_ft }}</th> 
                                </tr>
                                <tr v-if="apartmentdetail && apartmentdetail.bedroom_two_m != ''">
                                    <th scope="col">Bedroom 2</th>
                                    <th scope="col">{{ (apartmentdetail.bedroom_two_m != '') ? apartmentdetail.bedroom_two_m : '0.0m x 0.0m' }}</th>
                                    <th scope="col">{{ (apartmentdetail.bedroom_two_ft != '') ? apartmentdetail.bedroom_two_ft : '0.0 x 0.0' }}</th> 
                                </tr> 
                                <tr v-if="apartmentdetail && apartmentdetail.balcony_one_m != ''">
                                    <th scope="col">Balcony Zone 1</th>
                                    <th scope="col">{{ (apartmentdetail.balcony_one_m != '') ? apartmentdetail.balcony_one_m : '0.0m x 0.0m' }}</th>
                                    <th scope="col">{{ (apartmentdetail.balcony_one_ft != '') ? apartmentdetail.balcony_one_ft  : '0.0 x 0.0' }}</th> 
                                </tr> 
                                <tr v-if="apartmentdetail && apartmentdetail.balcony_two_m != ''">
                                    <th scope="col">Balcony Zone 2</th>
                                    <th scope="col">{{ (apartmentdetail.balcony_two_m != '') ? apartmentdetail.balcony_two_m : '0.0m x 0.0m' }}</th>
                                    <th scope="col">{{ (apartmentdetail.balcony_two_ft != '') ? apartmentdetail.balcony_two_ft  : '0.0 x 0.0' }}</th> 
                                </tr>
                                <tr v-if="apartmentdetail && apartmentdetail.terrace_one_m != ''">
                                    <th scope="col">Terrace Zone 1</th>
                                    <th scope="col">{{ (apartmentdetail.terrace_one_m != '') ? apartmentdetail.terrace_one_m : '0.0m x 0.0m' }}</th>
                                    <th scope="col">{{ (apartmentdetail.terrace_one_ft != '') ? apartmentdetail.terrace_one_ft  : '0.0 x 0.0' }}</th> 
                                </tr>
                                <tr v-if="apartmentdetail && apartmentdetail.terrace_two_m != ''">
                                    <th scope="col">Terrace Zone 2</th>
                                    <th scope="col">{{ (apartmentdetail.terrace_two_m != '') ? apartmentdetail.terrace_two_m : '0.0m x 0.0m' }}</th>
                                    <th scope="col">{{ (apartmentdetail.terrace_two_ft != '') ? apartmentdetail.terrace_two_ft  : '0.0 x 0.0' }}</th> 
                                </tr>
                                <tr v-if="apartmentdetail && apartmentdetail.terrace_three_m != ''">
                                    <th scope="col">Terrace Zone 3</th>
                                    <th scope="col">{{ (apartmentdetail.terrace_three_m != '') ? apartmentdetail.terrace_three_m : '0.0m x 0.0m' }}</th>
                                    <th scope="col">{{ (apartmentdetail.terrace_three_ft != '') ? apartmentdetail.terrace_three_ft  : '0.0 x 0.0' }}</th> 
                                </tr>
                            </tbody>
                        </table>
                        <div class="w-100 text-center b-10-white">
                            <img :src="apartmentdetail.plot_image" class="w-100">
                        </div>
                    </div>

                    <div class="col-lg-7 justify-content-center align-items-end pb-3 pe-3 " :class="(this.type == 'favouritesPage') ? 'FavouriteImageSide' : 'RightImageSide'">
                        <!-- <img src="../../assets/img/icon1.png" class="wid-20 d-block text-center ms-auto me-auto">
                        <span class="colorblue d-block text-center ms-auto me-auto fs-08 mb-4">RIVERSIDE VIEWS</span> -->
                        <div class="d-flex  fs-09 mt-3 specsandprice">
                            <div class="flex-fill">
                                Type: {{ apartmentdetail.type_2 }} 
                                <br /> Tenure: {{ apartmentdetail.tenure }}
                            </div>
                            <!-- <div class="d-flex justify-content-end gap-3"  v-if="apartmentdetail.status == 'available'">
                                Price: £{{ formatPrice(apartmentdetail.asking_price) }} 
                            </div> -->
                            <div class="d-flex justify-content-end gap-2 align-items-center">
                                <span class="color-box" :class="apartmentdetail.status"></span> 
                                <span class="status-text">{{ apartmentdetail.show_status }} </span>
                            </div>
                        </div>
                        
                        <div class="text-center">
                            <img @click='pop(apartmentdetail.plot_plate)'  :src="apartmentdetail.plot_plate" v-if="ParkingModel == false">
                            <img @click='pop(apartmentdetail.carparking)' class="parkingImg pt-5" :src="apartmentdetail.carparking" v-if="ParkingModel != false">
                         </div> 
                        <div class="d-flex align-items-center park-margin text-unset">
                            <div class="flex-fill pe-3">
                                <img src="../../assets/img/key.png" class="w-100 d-block cursor-pointer" >
                            </div>
                            <div class="d-flex justify-content-end gap-3" >
                                <img @click="AddToFavourites(apartmentdetail.id)" src="../../assets/img/star1.png" class="wid-20 d-block cursor-pointer" v-if="!CheckCookies.includes(apartmentdetail.id)">
                                <img @click="RemoveFromFavourites(apartmentdetail.id)" src="../../assets/img/starfill.png" class="wid-20 d-block cursor-pointer" v-if="CheckCookies.includes(apartmentdetail.id)">
                                <img v-if="fromfavourites != true" @click="$emit('CloseInnerModal', apartmentdetail.id)" src="../../assets/img/close1.jpg" class="wid-20 d-block cursor-pointer">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <viewer :images="images">
      <img v-for="src in images" :key="src" :src="src">
    </viewer>
    
    <div class="MobileView">
        <div class="container-wrap ">
            <div class="TableContent">
                <div class="row d-flex justify-content-end align-items-end ">
                    <div class="col-lg-5 left-box ps-4 pe-4 ">
                        <h2 class="mt-4">
                            {{ "LEVEL "+apartmentdetail.floor_level }} / {{ apartmentdetail.flat_no }}
                        </h2>
                        <span class="d-block fs-08">
                            {{ apartmentdetail.beds }} Bedroom Apartment / Total {{ apartmentdetail.gia }} sq m /  {{ apartmentdetail.sqm }} sq ft
                        </span> 
                        <table class="table mt-1">
                            <tbody>
                                <tr>
                                    <th scope="col">Kitchen/Living/Dining</th>
                                    <th scope="col">{{ apartmentdetail.kitchen_living_m  }}</th>
                                    <th scope="col">{{ apartmentdetail.kitchen_living_ft  }}</th> 
                                </tr>
                                <tr>
                                    <th scope="col">Bedroom 1</th>
                                    <th scope="col">{{ apartmentdetail.principal_bedroom_m  }}</th>
                                    <th scope="col">{{ apartmentdetail.principal_bedroom_ft  }}</th> 
                                </tr>
                                <tr v-if="apartmentdetail.bedroom_two_m != ''">
                                    <th scope="col">Bedroom 2</th>
                                    <th scope="col">{{ apartmentdetail.bedroom_two_m  }}</th>
                                    <th scope="col">{{ apartmentdetail.bedroom_two_ft  }}</th> 
                                </tr> 
                                <tr v-if="apartmentdetail.balcony_one_m != ''">
                                    <th scope="col">Balcony Zone 1</th>
                                    <th scope="col">{{ (apartmentdetail.balcony_one_m != '') ? apartmentdetail.balcony_one_m : '0.0m x 0.0m' }}</th>
                                    <th scope="col">{{ (apartmentdetail.balcony_one_ft != '') ? apartmentdetail.balcony_one_ft  : '0.0 x 0.0' }}</th> 
                                </tr> 
                                <tr v-if="apartmentdetail.balcony_two_m != ''">
                                    <th scope="col">Balcony Zone 2</th>
                                    <th scope="col">{{ (apartmentdetail.balcony_two_m != '') ? apartmentdetail.balcony_two_m : '0.0m x 0.0m' }}</th>
                                    <th scope="col">{{ (apartmentdetail.balcony_two_ft != '') ? apartmentdetail.balcony_two_ft  : '0.0 x 0.0' }}</th> 
                                </tr>
                                <tr v-if="apartmentdetail.terrace_one_m != ''">
                                    <th scope="col">Terrace Zone 1</th>
                                    <th scope="col">{{ (apartmentdetail.terrace_one_m != '') ? apartmentdetail.terrace_one_m : '0.0m x 0.0m' }}</th>
                                    <th scope="col">{{ (apartmentdetail.terrace_one_ft != '') ? apartmentdetail.terrace_one_ft  : '0.0 x 0.0' }}</th> 
                                </tr>
                                <tr v-if="apartmentdetail.terrace_two_m != ''">
                                    <th scope="col">Terrace Zone 2</th>
                                    <th scope="col">{{ (apartmentdetail.terrace_two_m != '') ? apartmentdetail.terrace_two_m : '0.0m x 0.0m' }}</th>
                                    <th scope="col">{{ (apartmentdetail.terrace_two_ft != '') ? apartmentdetail.terrace_two_ft  : '0.0 x 0.0' }}</th> 
                                </tr>
                                <tr v-if="apartmentdetail.terrace_three_m != ''">
                                    <th scope="col">Terrace Zone 3</th>
                                    <th scope="col">{{ (apartmentdetail.terrace_three_m != '') ? apartmentdetail.terrace_three_m : '0.0m x 0.0m' }}</th>
                                    <th scope="col">{{ (apartmentdetail.terrace_three_ft != '') ? apartmentdetail.terrace_three_ft  : '0.0 x 0.0' }}</th> 
                                </tr> 
                            </tbody>
                        </table>
                        <img :src="apartmentdetail.plot_image" class="w-100 plot_image">
                    </div>
                    <div class="col-lg-7 bg-white justify-content-center align-items-end pb-3 px-0 pt-3">
                        <!-- <img src="../../assets/img/icon1.png" class="wid-20 d-block text-center ms-auto me-auto">
                        <span class="colorblue d-block text-center ms-auto me-auto fs-08 mb-4">RIVERSIDE VIEWS</span> -->
                        <div class="d-flex fs-09 mb-3 px-4 specsandprice">
                            <div class="flex-fill ">
                                Type: {{ apartmentdetail.type_2 }} 
                                <br /> Tenure: {{ apartmentdetail.tenure }}
                            </div>
                            <div class="d-flex justify-content-end gap-2" v-if="apartmentdetail.status != 'available'">
                                <span class="color-box" :class="apartmentdetail.status"></span> 
                                <span class="status-text">{{ apartmentdetail.status }} </span>
                            </div>
                        </div>
                        <div class="Image_box">
                            <img @click='pop(apartmentdetail.plot_plate)' :src="apartmentdetail.plot_plate" >
                        </div>
                        <div class="d-flex align-items-center park-margin">
                            <div class="flex-fill px-3">
                                <img src="../../assets/img/key.png" class="w-100 d-block cursor-pointer" >
                            </div>
                            <div class="d-flex justify-content-end gap-3">
                                <img  @click="AddToFavourites(apartmentdetail.id)" src="../../assets/img/star1.png" class="wid-20 d-block cursor-pointer" v-if="!CheckCookies.includes(apartmentdetail.id)">
                                <img @click="RemoveFromFavourites(apartmentdetail.id)" src="../../assets/img/starfill.png" class="wid-20 d-block cursor-pointer" v-if="CheckCookies.includes(apartmentdetail.id)">
                                <img v-if="fromfavourites != true" @click="$emit('CloseInnerModal',apartmentdetail.id)" src="../../assets/img/close1.jpg" class="wid-20 d-block cursor-pointer">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import { $vfm, VueFinalModal, ModalsContainer } from 'vue-final-modal'
import { Swiper, SwiperSlide } from 'swiper/vue';

// Import Swiper styles
import 'swiper/css';
import "swiper/css/navigation"
import "swiper/css/thumbs"

// import Swiper core and required modules
import SwiperCore, {
    FreeMode, Navigation, Thumbs,
} from 'swiper';

// install Swiper modules
SwiperCore.use([FreeMode, Navigation, Thumbs]);

export default {
    name: 'FloorDetails',
    components: {
        VueFinalModal,
        Swiper,
        SwiperSlide
    },
    props: {
        id: "",
        type: "",
        viewtype: "",
        fromfavourites: Boolean,
    },
    created() {
        this.apartmentdetail = [];
        this.GetApartmentDetail(this.id);
        this.UpdateStar();
        this.FloorViewCount();
    },
    data(){
        return {
            thumbsSwiper: null,
            apartmentdetail: [],
            CheckCookies: [],
            NewImage: "",
            NewModal:false,
            ParkingModel:false,
        };
    },
    methods: {
        setThumbsSwiper(swiper) {
            this.thumbsSwiper = swiper;
        },
        UpdateStar(){
            if(this.$cookies.get('favourites') != null){
                this.CheckCookies = JSON.parse(this.$cookies.get('favourites'))
            }
        },
        GetApartmentDetail(id){
            fetch(this.base_url+'GetApartmentDetailByID&id='+id)
            .then(response => response.json())
            .then(res => {
                this.apartmentdetail = res.data
            });
        },
        AddToFavourites(id){

            let favdata = { 
                apartment_id: id,
                type: this.viewtype
            }

            fetch(this.base_url+'AddApartmentFavourites',{
                method: 'POST', // or 'PUT'
                headers: {
                    
                },
                body: JSON.stringify(favdata),
                })
            .then(response => response.json())
            .then(res => {
               
            });

           let data = { 
                session_id: sessionStorage.getItem('session_id'),
                plot_id: id
            }
            fetch(this.base_url+'addtofavourite',{
                method: 'POST', // or 'PUT'
                headers: {
                    
                },
                body: JSON.stringify(data),
                })
            .then(response => response.json())
            .then(res => {
                sessionStorage.setItem('session_id', res.data.session_id);

                if(id != null){
                    let favoritesId = this.$cookies.get('favourites')
                    if(favoritesId == null){
                        this.$cookies.set('favourites',JSON.stringify([id]),"0" );
                    }else{
                        let newFavourite = JSON.parse(favoritesId);
                        if(!newFavourite.includes(id)){
                            newFavourite.push(id);
                        }
                        this.$cookies.set('favourites',JSON.stringify(newFavourite),"0");
                    }
                    this.UpdateStar();
                }
                //this.$cookies.set('favourites',user);
            });

            
        },
        RemoveFromFavourites(id){
            let favoritesId = JSON.parse(this.$cookies.get('favourites'));
            let i = favoritesId.indexOf(id);
            favoritesId.splice(i,1);
            this.$cookies.set('favourites',JSON.stringify(favoritesId),"0");
            this.UpdateStar();
            this.$emit('UpdateFavourites')
        },
        pop(image){
            this.NewImage = image;
            var modal = document.getElementById("myModal");
            modal.style.display = "block";
        },
        ClosePop(){
            var modal = document.getElementById("myModal");
            modal.style.display = "none";
        },
        pop(image){
            this.$viewerApi({
                images: [image],
            })
        },
        formatPrice(value) {
            let val = (value/1)
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        },
        FloorViewCount(){
            let data = { 
                apartment_id: this.id,
                type: 'apartment'
            }
            fetch(this.base_url+'AddFloorView',{
                method: 'POST', // or 'PUT'
                headers: {
                    
                },
                body: JSON.stringify(data),
                })
            .then(response => response.json())
            .then(res => {
                
            });
        
        }
    },
    emits: ['CloseInnerModal','UpdateFavourites']
};
</script>

<style scoped lang="scss">

.DesktopView, .MobileView {
    font-family: 'rustica-light';
}

.b-10-white{
    border:10px solid #fff;
}

.cursor-pointer {
  cursor: pointer;
}

.location-text{
    font-size: initial;
}

.specsandprice {
  color: #381B31;
  text-transform: uppercase;
}

.theme-color {
  color: #381B31;
  font-size: 0.8rem;
}

.container-wrap {
    background: #fff;
    padding: 0px;
    margin: auto;
}
.fs-08{
    font-size: 0.8rem;
}

.color-box {
  width: 10px;
  height: 10px;
  border-radius: 10px;
}

.status-text {
 text-transform: uppercase;
}

.desktopTable tr{
    vertical-align:middle
}

.wid-20{
    width:20px !important;
}
.wid-30{
    width:25px !important;
}
.heig-30{
    height:25px !important;
}
.colorblue{
    color:#381B31;
}
.btn-blue{
    display: inline-block;
    padding: 7px 20px;
    font-family: var(--bs-btn-font-family);
    font-size: 0.9rem;
    font-weight: 600;
    line-height: var(--bs-btn-line-height);
    color: #fff;
    text-align: center;
    text-decoration: none;
    vertical-align: middle;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
    border: var(--bs-btn-border-width) solid var(--bs-btn-border-color);
    border-radius: 0;
    background-color: #381B31;
    transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
}

//////////////////////
/// 
/// 
/// 
/// 
/// 
/// 

.RightImageSide img {
    width:81%
}



.FavouriteImageSide img {
    width:81%
}

.Image_box{
    width:100%;
    text-align:center;
    img {
        width: 300px;
        height: 300px;
        object-fit: contain;
    }
    .parkingImg{
        width:80% !important;
    }
    .bed_1 {
        width: 380px;
        height: 380px;
        object-fit: contain;
    }
    .bed_2 {
        width: 380px;
        height: 380px;
        object-fit: contain;
    }
    .bed_3 {
        width: 380px;
        height: 380px;
        object-fit: contain;
    }
}


.swiper {
    width: 100%;
    height: 100%;
}

.swiper-slide {
    text-align: center;
    font-size: 18px;
    background: #fff;

    /* Center slide text vertically */
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
}

.swiper-slide img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: contain;
}


.swiper {
    width: 100%;
    height: 300px;
    margin-left: auto;
    margin-right: auto;
    z-index: 0;
}

.swiper-button-prev {
  color: #355063 !important;
}

.swiper-button-next {
  color: #355063 !important;
}

.swiper-button-next::after, .swiper-rtl .swiper-button-prev::after {
  color: red !important;
}

.swiper-slide {
    background-size: cover;
    background-position: center;
}

.mySwiper2 {
    height: 80%;
    width: 100%;

    div {
        background: transparent !important;
    }

    img {
        object-fit: contain !important;
    }
}

.mySwiper {
    height: 20%;
    box-sizing: border-box;
    padding: 10px 0;
}

.mySwiper .swiper-slide {
    width: 25%;
    height: 100%;
    opacity: 0.4;
}

.mySwiper .swiper-slide-thumb-active {
    opacity: 1;
}

.swiper-slide img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
}

//////////////////////////

.ImageViewer {
    cursor:pointer;
}

.btn-sold {
    background: #903737;
    color: #fff;
    text-transform: uppercase;
    width: 100px;
    height: 30px;
    font-size: 18px;
    //font-family: "aeonik-bold" !important;
    border: none;
}

.status-btn{
    color: #fff;
    text-transform: uppercase;
    width: auto;
    font-size: 18px;
    text-align:center;
    display: inline;
    margin-right:1rem;
    //font-family: "aeonik-bold" !important;
}


.available {
    //background:#E0E0D4;
    background:#00ca00
}

.not-released {
    background:#E0E0D4;
}

.reserved {
    background:orange;
}

.sold {
    background:red;
}

.sold-btn {
    background: red;
    color: #fff;
    text-transform: uppercase;
    width: 100px;
    height: 30px;
    font-size: 16px;
    border: none;
    //font-family: "aeonik-bold" !important;
}

.TableContent {
    box-shadow: 3px 3px 10px #000;
    border: 2px solid #cad636;
    .row{
        margin:0px 
    }
    .left-box {
        color:#fff;
        background:#381B31;
        span{
            text-transform: uppercase;
            font-size: 0.9rem;
        }
        h2 {
            font-size: 2.4rem;
            text-transform: uppercase;
        }

        h4 {
            //font-family: "aeonik-bold";
            font-size: 19px;
            color: #355063
        }

        .table {
            border: none;
            thead,
            tbody,
            tr,
            th {
                border: none;
                padding: 10px 3px;
                color: #fff;
                background: #381b31;
            }
            tr{
                border-bottom: 1px solid #fff;
            }
            th {
                //font-family: "aeonik-bold" !important;
                font-weight: 500;
                font-size: 0.7rem;
            }
            td {
                border: none;
                padding: 3px;
                color: #fff;
                font-size: 0.8rem;
            }
        }
    }

    .right-box {
        img{
            width: 270px;
        }
    }
}

.DarkBlue {
    background: #355063;
    color: #fff;
    padding: 10px 20px;

    div:nth-child(2){
        width: 50px;

    }
    h2 {
        font-size: 20px;
       // font-family: "aeonik-bold";
        margin-bottom: 0;
        display:inline
    }
    .bi-x {
        
        font-size:24px;
    }
}

.DesktopView{
    border: 0px solid #0231c9;
    text-align: initial;
}

.MobileView{
    display:none;
    border: 0px solid #0231c9;
    text-align: initial;
}

 /* Style the Image Used to Trigger the Modal */
#myImg {
  border-radius: 5px;
  cursor: pointer;
  transition: 0.3s;
}

#myImg:hover {opacity: 0.7;}

/* The Modal (background) */
.myModal {
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 1; /* Sit on top */
  padding-top: 100px; /* Location of the box */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0,0,0); /* Fallback color */
  background-color: rgba(0,0,0,0.9); /* Black w/ opacity */
}

/* Modal Content (Image) */
.modal-content {
  margin: auto;
  display: block;
  width: 80%;
  max-width: 700px;
}

/* Add Animation - Zoom in the Modal */
.modal-content, #caption {
  animation-name: zoom;
  animation-duration: 0.6s;
}

@keyframes zoom {
  from {transform:scale(0)}
  to {transform:scale(1)}
}

/* The Close Button */
.close {
  position: absolute;
  top: 70px;
  right: 35px;
  color: #f1f1f1;
  font-size: 40px;
  font-weight: bold;
  transition: 0.3s;
  z-index: 9999;
  cursor:pointer
}

.close:hover,
.close:focus {
  color: #bbb;
  text-decoration: none;
  cursor: pointer;
}

.park-margin{
    margin: 5px 5px 0 0px;
}

.fs-09{
    font-size: 0.9rem;
}



/* 100% Image Width on Smaller Screens */

@media screen and (min-width: 1440px) {
    .RightImageSide img {
        width:81%
    }

    .parkingImg {
        width: 81% !important;
    }

    .vertical {
        width:51%  !important
    }

    .square {
        width:45%  !important
    }

    .horizontal {
        width:100%  !important
    }
}

@media screen and (max-width: 1365px) {
    .MobileView {
        display:Block !important;
    }
    .DesktopView {
        display:none !important;
    }

}

@media screen and (max-width: 1366px) {
    .parkingImg {
        width: 79.2% !important;
    }

    .vertical {
        width:41%  !important
    }

    .square {
        width:51%  !important
    }
    .horizontal {
        width:100%  !important
    }
}

@media screen and (max-width: 991px) {
    .plot_image{
        display:none;
    }
}

@media screen and (max-width: 800px) {
    .container-wrap {
        .TableContent {
            .row {
                padding: 0 !important
            }
        }
    }

    .park-margin{
        margin: 30px 10px 0 10px;
    }

}

@media only screen and (max-width: 700px){
  .modal-content {
    width: 100%;
  }

  .TableContent .left-box h2 {
    font-size: 1.5rem;
    text-transform: uppercase;
}


  .Image_box{
        img {
            width: 250px;
            height: 250px;
            object-fit: contain;
        }

        .parkingImg {
            width: 250px;
            height: 250px;
            object-fit: contain;
        }
    }

    .park-margin {
        margin: 20px 10px 0 10px;
    }

} 

</style>
